import { Breakpoint, Divider, Slide } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { TransitionProps } from '@mui/material/transitions';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '..';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction='up' ref={ref} {...props} />;
});

interface AppDialogProps {
  open: boolean;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  onCancel?: () => void;
  onConfirm?: () => void;
  children?: React.ReactNode;
  bottomDivider?: boolean;
  maxWidth?: Breakpoint | false;
  disableTransition?: boolean;
  isVisible?: boolean;
  isVisibleConfirm?: boolean;
  colorConfirm?: string;
  colorHover?: string;
  fullWidth?: boolean;
  isDisabledBtn?: boolean;
}

const AppDialog: FC<AppDialogProps> = ({
  open,
  title,
  confirmText = 'common.confirm_text',
  cancelText = 'common.cancel_label',
  onCancel,
  onConfirm,
  children,
  bottomDivider,
  maxWidth,
  disableTransition,
  isVisible = true,
  isVisibleConfirm = true,
  colorConfirm,
  colorHover,
  fullWidth = true,
  isDisabledBtn = false,
}) => {
  const { t } = useTranslation();
  return (
    <Dialog
      fullWidth={fullWidth}
      open={open}
      TransitionComponent={disableTransition ? undefined : Transition}
      maxWidth={maxWidth}
      className='Dialog-custom-css'
    >
      {title && (
        <>
          <DialogTitle>{t(title!)}</DialogTitle>
          <Divider sx={{ mx: 3 }} />
        </>
      )}

      <DialogContent>{children}</DialogContent>
      {bottomDivider && <Divider sx={{ mx: 3 }} />}
      <DialogActions sx={{ justifyContent: 'center' }}>
        {isVisible && (
          <Button
            title={t(cancelText)}
            onClick={onCancel}
            typeName='secondary'
          />
        )}
        {isVisibleConfirm && (
          <Button
            onClick={onConfirm}
            title={t(confirmText)}
            sx={{
              background: colorConfirm,
              '&:hover': {
                backgroundColor: colorHover ?? colorConfirm,
              },
            }}
            disabled={isDisabledBtn}
            typeName='primary'
          />
        )}
      </DialogActions>
    </Dialog>
  );
};

export default AppDialog;
